import { render, staticRenderFns } from "./FlighttransferTab.vue?vue&type=template&id=a23e3dea&scoped=true"
import script from "./FlighttransferTab.vue?vue&type=script&lang=js"
export * from "./FlighttransferTab.vue?vue&type=script&lang=js"
import style0 from "./FlighttransferTab.vue?vue&type=style&index=0&id=a23e3dea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a23e3dea",
  null
  
)

export default component.exports